import {H3} from '@jetbrains/ring-ui/components/heading/heading'
import classNames from 'classnames'
import ordinal from 'ordinal'

import EntityPath from '../../../containers/EntityPath'
import {EntityProvider} from '../../../contexts/entity'
import BuildChangesDropdown from '../../packages/Changes/BuildChangesDropdown/BuildChangesDropdown'
import BuildDurationEstimate from '../BuildDurationEstimate/BuildDurationEstimate'
import BuildTriggeredBy from '../BuildTriggeredBy/BuildTriggeredBy.container'
import CompatibleAgents from '../CompatibleAgents/CompatibleAgents.container'
import Link from '../Link/Link'
import MoveToTop from '../MoveToTop/MoveToTop.container'
import StopBuild from '../StopBuild/StopBuild.container'

import type {Props} from './QueuedBuildInfo.types'

import styles from './QueuedBuildInfo.css'

function QueuedBuildInfo({
  buildId,
  buildTypeId,
  className,
  buildUrl,
  queuePosition,
  waitReason,
  withPath,
  projectOrBuildTypeFilter,
}: Props) {
  return (
    <EntityProvider buildId={buildId}>
      <div className={classNames(styles.info, className)}>
        {withPath === true && (
          <H3 className={styles.path}>
            <EntityPath
              buildTypeId={buildTypeId}
              projectOrBuildTypeNode={projectOrBuildTypeFilter}
            />
          </H3>
        )}
        <div className={styles.header}>
          <Link href={buildUrl} className={styles.link}>
            {queuePosition != null && (
              <span className={styles.position}>{ordinal(queuePosition)}</span>
            )}
            {waitReason}
          </Link>
          <BuildDurationEstimate />
        </div>
        <div className={styles.row}>
          <div className={styles.triggered}>
            <BuildTriggeredBy buildId={buildId} />
          </div>
          <div className={styles.actions}>
            <StopBuild buildId={buildId} />
            <MoveToTop buildId={buildId} />
          </div>
        </div>
        <div className={styles.row}>
          <CompatibleAgents buildId={buildId} />
          <BuildChangesDropdown buildId={buildId} className={styles.changes} />
        </div>
      </div>
    </EntityProvider>
  )
}

export default QueuedBuildInfo
